import { boolean, dateTime, defineAction, enumerated, object, string } from '~/prix'
import entrepreneurAgentRequestCancel from './entrepreneurAgentRequestCancel.action.json' with { type: 'json' }

const entrepreneurAgentRequestCancelDefinition = defineAction({
  ...entrepreneurAgentRequestCancel,
  userActivityLogInput: 'omit' as const,
  operation: 'update' as const,
  input: object({
    id: string(),
  }),
  output: object({
    success: boolean(),
    state: enumerated({
      canceled: 'canceled',
    }),
    closedAt: dateTime(),
  }),
})

export default entrepreneurAgentRequestCancelDefinition
